import {
  Create,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
} from "react-admin";

export const RoleCreate = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("roles.create") ||
      permissions.includes("roles.*") ||
      permissions.includes("*")
    )
  )
    return null;

  return (
    <Create title="Create Role" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Role created successfully", { type: "success" })
        }
      >
        <TextInput source="name" required />
        <TextInput source="description" />
      </SimpleForm>
    </Create>
  );
};